import { setupSiteConfig } from '~/composables/craft'

export function setupDepartment() {
  const localePath = useLocalePath()
  const { site } = setupSiteConfig()

  return {
    getUrl: (department) => {
      if (!department) return undefined
      if (department.urlOverride) return department.urlOverride
      switch (site) {
        case 'ikZoekBaas':
        case 'mijnDierIsZoek':
          return localePath({ name: 'shelter-detail', params: { departmentTypeSlug: department.departmentType?.slug, siteSlug: department.slug } })
        default:
          return localePath({ name: 'landing-detail', params: { departmentTypeSlug: department.departmentType?.slug, siteSlug: department.slug } })
      }
    },
  }
}
